/** 
 * @module cancelable-promise 
 * @description Represents cancelable promise wrapping which future 
 *              execution can be rejected externally by cancel call.
 */
const cancelable = (promise) => {
	let hasCanceled = false;

	const wrap = new Promise((resolve, reject) => {
		promise.then(
			val => hasCanceled ? reject({isCanceled: true}) : resolve(val),
			error => hasCanceled ? reject({isCanceled: true}) : reject(error)
		);
	});

	return {
		promise: wrap,
		cancel() {
			hasCanceled = true;
		}
	}
};

export default cancelable;



// WEBPACK FOOTER //
// ./src/util/cancelable-promise.js